import { portalsAPI } from './axios/portalsAPI';

export const fetchPriceRange = (body) => {
  return portalsAPI.post(`/pricing/prequal-investment-range`, body);
};

export const fetchScenarios = (body) => {
  return portalsAPI.post(`/pricing/scenarios`, body);
};
